var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMobile = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/mobile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6673 5.83366V14.167C14.6673 17.5003 13.834 18.3337 10.5007 18.3337H5.50065C2.16732 18.3337 1.33398 17.5003 1.33398 14.167V5.83366C1.33398 2.50033 2.16732 1.66699 5.50065 1.66699H10.5007C13.834 1.66699 14.6673 2.50033 14.6673 5.83366Z",
    stroke: "#333335",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.66732 4.58398H6.33398",
    stroke: "#333335",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.00065 15.9173C8.71402 15.9173 9.29232 15.339 9.29232 14.6257C9.29232 13.9123 8.71402 13.334 8.00065 13.334C7.28728 13.334 6.70898 13.9123 6.70898 14.6257C6.70898 15.339 7.28728 15.9173 8.00065 15.9173Z",
    stroke: "#333335",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMobile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mobile.e0e1ef22.svg";
export { ForwardRef as ReactComponent };